import React from 'react';

const MoreIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path d="M0 0L24 0 24 24 0 24z" transform="translate(-312 -120) translate(0 96) translate(312 24)" />
                <path fill="#21272E" fillRule="nonzero" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" transform="translate(-312 -120) translate(0 96) translate(312 24)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default MoreIcon;
